module.exports = __webpack_public_path__ + "img/laba.03de07c6.png";